
export class QuestionReqModel {
    qnos: string;
    sectionId: number;
    className: number;
    language: number;
    subject: number;
    chapter: number;
    topic: number;
    difficultyLevel: number;
    questionType: number;
    weightage: number;
    noOfQns: number;
    constructor(
        className: number,
        language: number,
        subject: number,
        chapter: number,
        topic: number,
        difficultyLevel: number,
        questionType: number,
        weightage: number,
        noOfQns: number,
    ) {
        this.className = className;
        this.language = language;
        this.subject = subject;
        this.chapter = chapter;
        this.topic = topic;
        this.difficultyLevel = difficultyLevel;
        this.questionType = questionType;
        this.weightage = weightage;
        this.noOfQns = noOfQns;
    }
}